import { IInventoryPage } from '../../inventory-page.interface';


export const SUPPORT_REPORT_PAGE: IInventoryPage = {
	'route': '/support/report',
	'title': 'Report',
	'uiReference': [],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/support-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/report/report.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/report/report.component.html'
	]
};
